import React, { useState } from "react";
import { ToastClear, ToastContent, ToastLoading, ValidEmail } from "../factory/FactoryUtil";
import { BodyView, ButtonView, InputView, HeaderTitleView } from "../factory/ViewUtil";
import { NavBar } from "antd-mobile";
import { ForgotSendCode } from "../../NetworkFactory";

const ForgotViewController = ({goback, navpush}) => {
    const [email, setEmail] = useState('')
    const showError = () => {
        ToastContent(' Network or Unknown error')
    }

    const doNext = () => {
        if(email.length < 3) {
            ToastContent('Please enter your email address')
            return
        }
        if(!ValidEmail(email)) {
            ToastContent('Email is invalid')
            return
        }
        // # 请求数据
        ToastLoading('Loading...')
        ForgotSendCode(email).then(response => {
            ToastClear()
            const {id, status} = response.data || {}
            if(id) {
                navpush('/forgot_code', false, {
                    id : id,
                    email : email
                })
                return
            }
            if(status === -1) {
                ToastContent('The user does not exist')
                return
            }
            else if(status === 0) {
                ToastContent('Failed to send verification code')
                return
            }
            showError()
        }).catch((error) => {
            let {status = -1} = error || {}
            if(status === 509) {
                ToastContent('Access too fast')
                return
            }
            ToastClear()
            showError()
        })
    }
    return(
        <>
            <NavBar onBack = {goback}></NavBar>
            <BodyView>
                <HeaderTitleView>Please provide your email</HeaderTitleView>
                <InputView value={email} onChange={val => {setEmail(val)}} title='Your Email' clearable/>
                <ButtonView onClick={doNext} style={{ width : '100%', marginTop: '20px'}}>Next</ButtonView>
            </BodyView>
        </>
    )
}

export default React.memo(ForgotViewController)